module.exports = __webpack_public_path__ + "img/i-seat-common.7f060c39.svg";